export default __webpack_public_path__ + "static/media/mysteryBet.0996ebd7.png";